export const GAME_BOX = 'game-box';
export const GAME_BOX_JACKPOT_TEMPLATE = 'game-box-jackpot-template';
export const TWO_LINES_TITLE = 'two-lines-title';
export const GAME_GROUP_LIVE_CASINO = 'game-group-live-casino';
export const ENABLE_HOVER_ANIMATION = 'enable-hover-animation';
export const SWIPER_MODE = 'swiper-mode'; //.orbit-slider-slide
export const GAME_IMAGE_CONTAINER = 'game-image-container';
export const GRID_GAMES_LIST = 'grid-games-list'; //TODO - I should do something with this when I will refactor games grid list
export const SINGLE_GAME_IMAGE = 'single-game-image';
